import React from "react";
import {
  bgColor,
  colorLightGrey,
  colorWhite,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import {
  CLIENT,
  RUPEES_SYMBOL,
  TRANSACTION_PAYIN_ACL,
  TRANSACTION_PAYOUT_ACL,
  TRANSACTION_PREFUND_ACL,
  TRANSACTION_VAN_ACL,
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import { useSelector } from "react-redux";
import moment from "moment";
import { AiOutlineInfoCircle } from "react-icons/ai";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
const RowContainer = ({
  title,
  value,
  color = "black",
  style,
  direction = "row",
  isRupees = true,
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 30,
        margin: "10px 0px",
        width: "100%",
        justifyContent: "space-between",
        padding: "0px 15px",
        flexDirection: direction,
        ...style,
      }}
    >
      <p
        style={{
          fontSize: 15,
          color: "#7A7979",
        }}
      >
        {title}
      </p>

      <p
        style={{
          fontSize: 17,
          fontWeight: "600",
          color,
        }}
      >
        {isRupees ? RUPEES_SYMBOL : ""} {value}
      </p>
    </div>
  );
};
function OverviewContainer({ style, data, aclData, clientData }) {
  return (
    <div
      style={{
        border: "1px solid rgba(52, 78, 130, 0.1)",
        backgroundColor: colorWhite,
        minWidth: 650,
        padding: "10px",
        borderRadius: "4px",
        ...style,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 15px",
          margin: "10px 0px",
        }}
      >
        <p>Transaction Count</p>
        <p
          style={{
            fontWeight: "600",
            color: primaryColor,
          }}
        >
          {data
            ? formatBalance(
                Number(
                  (data?.payin?.totalPayin ?? 0) +
                    (data?.payout?.totalPayout ?? 0) +
                    (data?.prefund?.totalCount ?? 0)
                )
              )
            : 0}
        </p>
      </div>
      <div
        style={{
          display: "flex",
        }}
      >
        {aclData.includes(TRANSACTION_PAYIN_ACL) && (
          <div style={styles.containerBorderStyle}>
            <RowContainer
              title="Total Payin"
              value={data?.payin?.totalPayin ? data?.payin?.totalPayin : 0}
              style={{
                marginBottom: 20,
              }}
              color={primaryColor}
              isRupees={false}
            />
            <RowContainer
              title="Success"
              value={data?.payin?.payinSuccess ? data?.payin?.payinSuccess : 0}
              isRupees={false}
            />
            <RowContainer
              isRupees={false}
              title="Failed"
              value={data?.payin?.payinFailure ? data?.payin?.payinFailure : 0}
            />
          </div>
        )}
        {aclData.includes(TRANSACTION_PAYOUT_ACL) && (
          <div
            style={{
              ...styles.containerBorderStyle,
              borderRight: " 1px solid rgb(217, 217, 217)",
            }}
          >
            <RowContainer
              isRupees={false}
              title="Total Payout"
              value={data?.payout?.totalPayout ? data?.payout?.totalPayout : 0}
              style={{
                marginBottom: 20,
              }}
              color={primaryColor}
            />
            <RowContainer
              isRupees={false}
              title="Success"
              value={
                data?.payout?.payoutSuccess ? data?.payout?.payoutSuccess : 0
              }
            />
            <RowContainer
              isRupees={false}
              title="Failed"
              value={
                data?.payout?.payoutFailure ? data?.payout?.payoutFailure : 0
              }
            />
          </div>
        )}
        {aclData.includes(TRANSACTION_PREFUND_ACL) && (
          <div
            style={{
              ...styles.containerBorderStyle,
            }}
          >
            <RowContainer
              isRupees={false}
              title="Total Prefund"
              value={data?.prefund?.totalCount ? data?.prefund?.totalCount : 0}
              style={{
                marginBottom: 20,
                width: "100%",
              }}
              color={primaryColor}
            />
            <RowContainer
              isRupees={false}
              title="Success"
              value={
                data?.prefund?.prefundSuccess
                  ? data?.prefund?.prefundSuccess
                  : 0
              }
            />
            <RowContainer
              isRupees={false}
              title="Failed"
              value={
                data?.prefund?.prefundFailure
                  ? data?.prefund?.prefundFailure
                  : 0
              }
            />
          </div>
        )}
        {aclData.includes(TRANSACTION_VAN_ACL) && (
          <div style={{ ...styles.containerBorderStyle, border: "none" }}>
            <RowContainer
              isRupees={false}
              title="Total Van"
              value={data?.van?.totalVanCount ? data?.van?.totalVanCount : 0}
              style={{
                marginBottom: 20,
                width: "100%",
              }}
              color={primaryColor}
            />
            <RowContainer
              isRupees={false}
              title="Success"
              value={data?.van?.vanSuccess ? data?.van?.vanSuccess : 0}
            />
            <RowContainer
              isRupees={false}
              title="Failed"
              value={data?.van?.vanFailure ? data?.van?.vanFailure : 0}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export const SettlementContainer = ({
  style,
  data,
  unsettledAmount,
  aclData,
  role,
}) => {
  const payinBalance = useSelector(
    (state) => state.dashboardCountSlice.clientBalance
  );
  const voucherBalance = useSelector(
    (state) => state.dashboardCountSlice.clientVoucherBalance
  );
  return (
    <div
      style={{
        minWidth: 375,
        maxWidth: 400,
        border: "1px solid rgba(52, 78, 130, 0.1)",
        backgroundColor: colorWhite,
        padding: "10px",
        borderRadius: "4px",
        ...style,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 15px",
          margin: "10px 0px",
        }}
      >
        <p style={{}}>Transaction Settlement</p>
        {/* <p
          style={{
            fontWeight: "600",
            color: primaryColor,
            textAlign: "left",
            width: "40%",
          }}
        >
          {RUPEES_SYMBOL +
            " " +
            formatBalance(
              Number(data?.totalSettledAmount ?? 0) +
                Number(unsettledAmount?.totalPayin ?? 0)
            )}
        </p> */}
      </div>

      <div>
        <div
          style={{
            ...styles.containerBorderStyle,
            flexDirection: "row",
            border: "none",
          }}
        >
          <RowContainer
            title="Settled amount"
            value={formatBalance(data?.totalSettledAmount ?? 0)}
            style={{
              alignItems: "center",
              borderRight: "1px solid #D9D9D9",
            }}
            color={primaryColor}
            direction="column"
          />
          <RowContainer
            title="Unsettled amount"
            value={
              //   formatBalance(
              //   Number(
              //     unsettledAmount?.totalPayin ? unsettledAmount?.totalPayin : 0
              //   )
              // )
              formatBalance(Number(payinBalance?.count + voucherBalance?.count))
            }
            style={{
              alignItems: "center",
            }}
            color={primaryColor}
            direction="column"
          />
        </div>

        {role !== CLIENT && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "10px 0px",
            }}
          >
            <AiOutlineInfoCircle size={12} />

            <p
              style={{
                fontSize: 12,
                marginLeft: 10,
                color: "#3C4048",
              }}
            >
              Apply Client filter to check un-settled amount{" "}
            </p>
          </div>
        )}
        {/* <p>
          last updated:{" "}
          {moment(data?.lastUpdated)
            // .utcOffset(0, false)
            .format("DD-MM-YYYY hh:mm A")}{" "}
        </p> */}
      </div>
    </div>
  );
};

export const TransactionVolume = ({ style, data, aclData }) => {
  return (
    <div
      style={{
        border: "1px solid rgba(52, 78, 130, 0.1)",
        backgroundColor: colorWhite,
        minWidth: 650,
        padding: "10px",
        borderRadius: "4px",
        ...style,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 15px",
        }}
      >
        <p>Transaction Volume</p>
        <p
          style={{
            fontWeight: "600",
            color: primaryColor,
            marginRight: 20,
          }}
        >
          {/* {RUPEES_SYMBOL}{" "}
          {formatBalance(Number(data?.totalVolume ? data?.totalVolume : 0))} */}
        </p>
      </div>
      <div
        style={{
          display: "flex",
        }}
      >
        {aclData?.includes(TRANSACTION_PAYIN_ACL) && (
          <RowContainer
            title="Total Payin"
            value={formatBalance(
              Number(data?.totalPayin ? data?.totalPayin : 0)
            )}
            style={{
              alignItems: "start",
              borderRight: "1px solid #D9D9D9",
            }}
            color={primaryColor}
            direction="column"
          />
        )}
        {aclData?.includes(TRANSACTION_PAYOUT_ACL) && (
          <RowContainer
            title="Total Payout"
            value={formatBalance(
              Number(data?.totalPayout ? data?.totalPayout : 0)
            )}
            style={{
              alignItems: "center",
              borderRight: "1px solid rgb(217, 217, 217)",
            }}
            color={primaryColor}
            direction="column"
          />
        )}
        {aclData?.includes(TRANSACTION_PREFUND_ACL) && (
          <RowContainer
            title="Total Prefund"
            value={formatBalance(
              Number(data?.totalPrefund ? data?.totalPrefund : 0)
            )}
            style={{
              alignItems: "center",
              borderRight: "1px solid #D9D9D9",
            }}
            color={primaryColor}
            direction="column"
          />
        )}
        {aclData?.includes(TRANSACTION_VAN_ACL) && (
          <RowContainer
            title="Total Van"
            value={formatBalance(Number(data?.totalVan ? data?.totalVan : 0))}
            style={{
              alignItems: "center",
            }}
            color={primaryColor}
            direction="column"
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  containerBorderStyle: {
    borderRight: "1px solid #D9D9D9",
    flex: 4 / 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
};
export default OverviewContainer;
